/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_Tab_DebtsInputs */

const vi_customer_tab_debts = /** @type {(inputs: Customer_Tab_DebtsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Công nợ`)
};

/**

* @param {Customer_Tab_DebtsInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_tab_debts = /** @type {((inputs?: Customer_Tab_DebtsInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_Tab_DebtsInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_tab_debts(inputs)
});